import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scroll to bottom of page on path change, overriding the app-wide `ScrollToTop`
 * for as long as this component is mounted.
 *
 * Works by running its own pathname-driven `scrollTo` effect. Because React
 * commits effects in post-order (children/later siblings after earlier
 * siblings), and `ScrollToTop` sits as an earlier sibling in the layout tree,
 * this component's scroll call runs *after* `ScrollToTop`'s. Consecutive
 * `scrollTo` calls in the same tick are coalesced by the browser, so the final
 * position (bottom) wins with no visible flash.
 */
const ScrollToBottom = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // `document.documentElement.scrollHeight` can be clamped to the viewport
    // height when `html` has a fixed height (as in this app's base.css), so
    // take the max of body + documentElement for robustness.
    const targetYposition = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
    window.scrollTo(0, targetYposition);
  }, [pathname]);

  return null;
};

export default ScrollToBottom;
